import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ReactElement, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TeamRole } from '../../api/graphql/generated';
import { useCurrentUserProp } from '../../api/user.hooks';
import { TeamList } from './team-list';

interface TeamExplorerProps {
  title?: string;
  presentingElement?: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
  onSelected: (teamId: string) => void;
}

const TeamExplorer = (props: TeamExplorerProps): ReactElement => {
  const { isOpen, onClose, onSelected, presentingElement, title } = props;
  const { i18n } = useTranslation();

  const isAdmin = useCurrentUserProp('admin');

  const explorerModalRef = useRef<HTMLIonModalElement>(null);
  const hasCalledOnClosed = useRef<boolean>(false);

  const onCloseHandler = useCallback(() => {
    onClose();
    hasCalledOnClosed.current = true;
  }, [onClose]);

  const titleText = title ?? i18n.t('common:team_select_team');

  return (
    <IonModal
      isOpen={isOpen}
      ref={explorerModalRef}
      canDismiss={true}
      presentingElement={presentingElement ?? undefined}
      onWillPresent={() => {
        hasCalledOnClosed.current = false;
      }}
      onDidDismiss={() => {
        if (hasCalledOnClosed.current === false) {
          onCloseHandler();
        }
      }}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton
              onClick={() => {
                onCloseHandler();
              }}
            >
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{titleText}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <TeamList
          onSelect={(id) => {
            onSelected(id);
            onCloseHandler();
          }}
          showRole={false}
          filterRow={({ item: team }) => {
            if (isAdmin || team.role === TeamRole.MANAGER) {
              return true;
            } else {
              return false;
            }
          }}
        />
      </IonContent>
    </IonModal>
  );
};

export { TeamExplorer };
